import { IFormConfiguration } from "../../../../hooks/useFilterConfig";

import { valuesToParams } from "../filters.functions";

import { ExecutionBriefFilterFields } from "./execution-brief-filters.component";
import { paramsToValues } from "./execution-brief-filters.functions";
import { validation } from "./execution-brief-filters.validation";

export const ExecutionBriefFilter: IFormConfiguration = {
  Fields: ExecutionBriefFilterFields,
  paramsToValues,
  validation,
  valuesToParams,
};
